import React from 'react';
import { PropTypes } from 'prop-types';

import styles from './CancelButton.css';

const CancelButton = ({ onCancel }) => (
  <button onClick={onCancel} className={styles.button}>
    Cancel
  </button>
);

CancelButton.propTypes = {
  onCancel: PropTypes.func.isRequired,
};

export default CancelButton;



// WEBPACK FOOTER //
// ./src/containers/Modals/CancelButton.jsx